import React, { Component } from "react";
import { Router } from "react-router-dom";

import HistoryObject from "./_Utils/History";

// Component
import RouterComponent from "./RouterComponent";

export default class App extends Component {
  render() {
    return (
      <div className="App">
        <Router history={HistoryObject}>
          <RouterComponent />
        </Router>
      </div>
    );
  }
}
